import type { ApiClient } from '../client';
import type { LockCodes } from '../schemas/lockCodes';

// Which of the cerradura's two code tables the confirmation moves. Derived from the read's schema
// rather than restated, so a third table could never mean two different things.
export type LockSequenceType = keyof LockCodes;

export interface ConfirmLockSequenceInput {
  type: LockSequenceType;
  deliveryId: string;
  // Where the server pointer stands now. Metric only — the backend does not validate it, so the
  // write is last-write-wins.
  oldPosition: number;
  // Position of the NEXT code to give once the agent's reading of the cerradura is accepted. Same
  // meaning as the read's `current_position`, so it is forwarded VERBATIM — never `+1`. Off by one
  // here and the code the agent reads out does not open the «buzón», which is the failure this
  // whole feature exists to prevent.
  newPosition: number;
}

// Move a code table's server pointer to where the agent says the cerradura actually is («Confirmar
// secuencia» — the panel's sixth WRITE). The lock id rides the path (url-encoded); the client
// attaches the Firebase token via the Authorization header.
//
// The body carries POSITIONS ONLY. No code value ever reaches the wire, so a request log or an APM
// trace cannot leak a credential that opens a «buzón».
//
// Empty 200 — nothing to parse; the caller refetches the codes, whose moved pointer is the effect.
// ⚠️ Proposed shape, unverified against app-service (CBX-10989 authored, undeployed) — mirror the
// delivered one on arrival.
export async function confirmLockSequence(
  client: ApiClient,
  lockId: string,
  input: ConfirmLockSequenceInput,
): Promise<void> {
  await client.post(`/app_service/panel/v1/locks/${encodeURIComponent(lockId)}/sequences`, {
    type: input.type,
    delivery_id: input.deliveryId,
    old_position: input.oldPosition,
    new_position: input.newPosition,
  });
}
